import { Spin } from "../standardization/YuJaLoading";
import React from "react";
import { Form, Modal } from "react-bootstrap";
import Select from "react-select";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import "./modal.css";
import useMobileAccess from "../../hooks/useMobileAccess";
import { useState, } from "react";
import YuJaButton from "../standardization/YuJaButton";
import {YuJaTextBox} from "../standardization/YuJaTextBox";
import "react-datepicker/dist/react-datepicker.css";
import { GRADED_POLL, BUTTON, CLOSE_MODAL, SELECT_LABEL, MODAL, TEXTBOX, PARTICIPANT_TIME_INTRO } from "../../utils/constants";
import parse from "html-react-parser";
import YuJaDialog from "../standardization/YuJaDialog";
import YuJaComboBox from "../standardization/YuJaComboBox";
import { useTranslation } from "react-i18next";


//isLoading is default to false, should be used when it requires to fetch data
export default function FormModal({ modalConfig, isLoading = false, setModalShow, show, pollTimeLimit = "00:30:00", setPollTimeLimit,  isWarning, startDate, endDate, setStartDate, setEndDate}) {
    const { t } = useTranslation();
  const [ shareInCourse, setShareInCourse ] = useState(false);
  const [ pollTimeLimitH, setPollTimeLimitH] = useState(pollTimeLimit.substring(0,2));
  const [ pollTimeLimitM, setPollTimeLimitM] = useState(pollTimeLimit.substring(3,5));
  const [ pollTimeLimitS, setPollTimeLimitS] = useState(pollTimeLimit.substring(6));


  const isNarrow = useMobileAccess(1100);


  const handleClose = () =>{
    setModalShow(false);
    modalConfig.clearForm();
  };


  // const handlePollTimeChangeH = (e) => {
  //   let hours = e.target.value.length <= 2 ? e.target.value : e.target.value.substring(0,2);
  //   document.getElementById("error2").innerText = "";
  //   setPollTimeLimitH(hours);

  //   if(hours === "") {
  //     hours = "00";
  //   } else if(hours.length === 1) {
  //     hours = "0"+hours;
  //   }
  //   setPollTimeLimit(hours + pollTimeLimit.substring(2));
  // };

  const handlePollTimeChangeH = (e) => {
    let hours = e.target.value.length <= 2 ? e.target.value : e.target.value.substring(0,2);
    document.getElementById("error2").innerText = "";
    setPollTimeLimitH(hours);
  };

  const handlePollTimeonBlurH = (e) => {
    let hours = pollTimeLimitH; 
    const isValidNumber = /^\d+$/.test(pollTimeLimitH);
    if(isValidNumber && !isNaN(parseInt(pollTimeLimitH, 10)) && parseInt(pollTimeLimitH, 10) <= 24 )
    {
    
    if(hours === "") {
      hours = "00";
    } else if(hours.length === 1) {
      hours = "0"+hours;
    }
    setPollTimeLimitH(hours);
    setPollTimeLimit(hours + pollTimeLimit.substring(2));
    if(parseInt(pollTimeLimitH, 10) === 0){
        setPollTimeLimitH("00");
    }
    }
    else {
        setPollTimeLimitH("00");
    }
  }

  // const handlePollTimeChangeM = (e) => {
  //   let mins = e.target.value.length <= 2 ? e.target.value : e.target.value.substring(0,2);
  //   document.getElementById("error2").innerText = "";
  //   setPollTimeLimitM(mins);

      
  //   if(mins === "") {
  //     mins = "00";
  //   } else if(mins.length === 1) {
  //     mins = "0"+mins;
  //   }
  //   setPollTimeLimit(pollTimeLimit.substring(0,3) + mins + pollTimeLimit.substring(5));
  // };

  const handlePollTimeChangeM = (e) => {
    let mins = e.target.value.length <= 2 ? e.target.value : e.target.value.substring(0,2);
    document.getElementById("error2").innerText = "";
    setPollTimeLimitM(mins);

  };

  const handlePollTimeonBlurM = (e) => {
    let mins = pollTimeLimitM; 
    const isValidNumber = /^\d+$/.test(pollTimeLimitM);
    if(isValidNumber && !isNaN(parseInt(pollTimeLimitM, 10)))
    {        
        let unroundedMins = (mins < 10 ? "0" + mins.toString() : mins.toString());
        let hours = Math.floor(parseInt(mins, 10) / 60); 
        mins = parseInt(mins, 10) % 60; 
        if(hours + parseInt(pollTimeLimitH, 10) > 24) {
            unroundedMins = (mins < 10 ? "0" + mins.toString() : mins.toString());
        }
        hours = hours + parseInt(pollTimeLimitH, 10) > 24 ? 24 : hours + parseInt(pollTimeLimitH, 10);

        if (mins === "") {
            mins = "00";
        } else if (mins.length === 1) {
            mins = "0" + mins;
        }
        setPollTimeLimitM((mins < 10 ? "0" : "") + mins)
        setPollTimeLimitH((hours < 10 ? "0" : "") + hours);
        setPollTimeLimit(pollTimeLimit.substring(0, 3) + unroundedMins + ":00");
        if (parseInt(pollTimeLimitM, 10) === 0) {
            setPollTimeLimitM("00");
        }
    }
    else {
        setPollTimeLimitM("00");
    }
  }

  // const handlePollTimeChangeS = (e) => {
  //   let secs = e.target.value.length <= 2 ? e.target.value : e.target.value.substring(0,2);
  //   document.getElementById("error2").innerText = "";
  //   setPollTimeLimitS(secs);

  //   if(secs === "") {
  //     secs = "00";
  //   } else if(secs.length === 1) {
  //     secs = "0"+secs;
  //   }
  //   setPollTimeLimit(pollTimeLimit.substring(0,6) + secs);
  // };

  const validateForm = () => {
    if(shareInCourse) {
      if(modalConfig.form[0].value.length === 0) {
        document.getElementById("error1").innerText = "Please select a course!";
        return false;
      } else {
        document.getElementById("error1").innerText = "";
      }
    }

    return true;
  };


  return (
      <YuJaDialog
          open={show}
          setOpen={setModalShow}
          title={modalConfig.title}
          closeText={t("common.cancel")}
          leftButtonText={modalConfig.leftButtonText}
          onLeft={() => modalConfig.left()}
          centerAligned={false}
          onSubmit={() => modalConfig.submit()}
          submitText={modalConfig.submitButtonText}
          clearForm={modalConfig.clearForm}
          onClose={modalConfig.onClose}
          isSubmitBtnDisabled={modalConfig.isSubmitBtnDisabled}
      >
          <Form className="customized-form" onSubmit={e => e.preventDefault()}>
              {modalConfig?.form[0]?.type !== 'select5' &&
                  <div style={{ marginBottom: "25px" }}>
                      <Form.Text tabIndex={0} role={TEXTBOX} className="form-subtext">
                          {modalConfig.subText}
                      </Form.Text>
                  </div>
              }

              {modalConfig.form.map((formItem, idx) => {
                  if (formItem.type === 'select2') {
                      return (
                          <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
                              <div className="activatePollText">{formItem.label}</div>
                              <div className="form-check" style={{marginTop: "10px"}}>
                                  <input className="form-check-input course-modal-input" type="radio" id="defaultCheck0" checked={!shareInCourse} onChange={() => {setShareInCourse(false); formItem.setFunction([]);}}/>
                                  <label className="form-check-label" htmlFor="defaultCheck0">{formItem.subOptions[0]}</label>
                              </div>
                              <div className="form-check" style={{marginBottom: "10px"}}>
                                  <input className="form-check-input course-modal-input" type="radio" id="defaultCheck1" checked={shareInCourse} onChange={() => {setShareInCourse(true)}}/>
                                  <label className="form-check-label" htmlFor="defaultCheck1">{formItem.subOptions[1]}</label>
                              </div>

                              {shareInCourse && <>
                                  <Select
                                      options={formItem.options}
                                      onChange={formItem.setFunction}
                                      value={formItem.value}
                                      isMulti={formItem.isMulti}
                                      isInvalid={!!formItem.error}
                                  />
                                  <div className="activatePollError" id="error1"></div>
                              </>}
                          </Form.Group>

                      );
                  }else if (formItem.type === 'select4') {
                      return (
                          <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
                              <Form.Label className="form-label" style={{marginTop: 10}}>
                                  {formItem.label}
                              </Form.Label>
                              <YuJaComboBox
                                  options={formItem.options}
                                  value={formItem.value}
                                  onChange={formItem.setFunction}
                                  multiple={true}
                                  style={{width: "100%"}}
                                  positionStyle={{zIndex: 1}}
                                  placeholder={t("sharePoll.selectMembers")}
                                  searchPlaceholder={t("sharePoll.searchMembersPlaceholder")}
                                  unitTerm={"member"}
                              />
                              {/*<Select*/}
                              {/*    aria-label={SELECT_LABEL + formItem.label}*/}
                              {/*    options={formItem.options}*/}
                              {/*    onChange={formItem.setFunction}*/}
                              {/*    value={formItem.value}*/}
                              {/*    isMulti={formItem.isMulti}*/}
                              {/*    isInvalid={!!formItem.error}*/}
                              {/*/>*/}
                              {!!formItem.error && <p style={{ color: "red" }}>{formItem.error}</p>}
                          </Form.Group>
                      );
                  } else {
                      return (
                          <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
                              <Form.Label className="form-label">
                                  {formItem.label}
                              </Form.Label>
                              <YuJaTextBox
                                  label={t("accessibility.textboxEnterPrefix") + formItem.label}
                                  containerStyle={{width: "90%"}}
                                  value={formItem.value || ""}
                                  onChange={(e) => formItem.setFunction(e.target.value)}
                                  type={formItem.type}
                                  isInvalid={!!formItem.error}
                                  errorMsg={formItem.error}
                              />

                              <Form.Control.Feedback type="invalid">
                                  {formItem.error}
                              </Form.Control.Feedback>
                          </Form.Group>
                      );
                  }

              })}
          </Form>
      </YuJaDialog>

    // <Modal
    //   id="form-modal"
    //   show={show}
    //   onHide={handleClose}
    //   aria-labelledby="contained-modal-title-vcenter"
    //   backdrop={isLoading ? "static" : true}
    //   dialogClassName= {"ac-modal"}
    // >
    //   <Spin tip="Loading..." size="large" spinning={isLoading}>
    //     <ModalClose tabIndex={0} role={BUTTON} aria-label={CLOSE_MODAL} onClick={handleClose} className="modal-close" />
    //     <Modal.Header
    //       style={{
    //         display: "flex",
    //         justifyContent: "center",
    //         alignItems: "center",
    //       }}
    //     >
    //       <Modal.Title
    //         className="modal-title"
    //         id="contained-modal-title-vcenter"
    //         tabIndex={0}
    //         aria-label={modalConfig.title + MODAL}
    //         role={TEXTBOX}
    //       >
    //         {modalConfig.title}
    //       </Modal.Title>
    //     </Modal.Header>
    //     <Modal.Body>
    //       <Form className="customized-form" onSubmit={e => e.preventDefault()}>
    //         {modalConfig?.form[0]?.type !== 'select5' &&
    //           <div style={{ marginBottom: "25px" }}>
    //             <Form.Text tabIndex={0} role={TEXTBOX} className="form-subtext">
    //               {modalConfig.subText}
    //             </Form.Text>
    //           </div>
    //         }
    //
    //         {modalConfig.form.map((formItem, idx) => {
    //           if (formItem.type === 'select2') {
    //             return (
    //                 <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
    //                   <div className="activatePollText">{formItem.label}</div>
    //                   <div className="form-check" style={{marginTop: "10px"}}>
    //                     <input className="form-check-input course-modal-input" type="radio" id="defaultCheck0" checked={!shareInCourse} onChange={() => {setShareInCourse(false); formItem.setFunction([]);}}/>
    //                     <label className="form-check-label" htmlFor="defaultCheck0">{formItem.subOptions[0]}</label>
    //                   </div>
    //                   <div className="form-check" style={{marginBottom: "10px"}}>
    //                     <input className="form-check-input course-modal-input" type="radio" id="defaultCheck1" checked={shareInCourse} onChange={() => {setShareInCourse(true)}}/>
    //                     <label className="form-check-label" htmlFor="defaultCheck1">{formItem.subOptions[1]}</label>
    //                   </div>
    //
    //                   {shareInCourse && <>
    //                   <Select
    //                       options={formItem.options}
    //                       onChange={formItem.setFunction}
    //                       value={formItem.value}
    //                       isMulti={formItem.isMulti}
    //                       isInvalid={!!formItem.error}
    //                   />
    //                   <div className="activatePollError" id="error1"></div>
    //                   </>}
    //                 </Form.Group>
    //
    //             );
    //           }else if (formItem.type === 'select4') {
    //             return (
    //               <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
    //                 <Form.Label tabIndex={0} role={TEXTBOX} className="form-label" style={{marginTop: 10}}>
    //                   {formItem.label}
    //                 </Form.Label>
    //                 <Select
    //                       aria-label={SELECT_LABEL + formItem.label}
    //                       options={formItem.options}
    //                       onChange={formItem.setFunction}
    //                       value={formItem.value}
    //                       isMulti={formItem.isMulti}
    //                       isInvalid={!!formItem.error}
    //                   />
    //                 {!!formItem.error && <p style={{ color: "red" }}>{formItem.error}</p>}
    //               </Form.Group>
    //             );
    //           } else {
    //             return (
    //                 <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
    //                   <Form.Label className="form-label">
    //                     {formItem.label}
    //                   </Form.Label>
    //                   <YuJaTextBox
    //                       label={TEXT_BOX_MODAL + formItem.label}
    //                       containerStyle={{width: "90%"}}
    //                       value={formItem.value || ""}
    //                       onChange={(e) => formItem.setFunction(e.target.value)}
    //                       type={formItem.type}
    //                       isInvalid={!!formItem.error}
    //                       errorMsg={formItem.error}
    //                   />
    //
    //                   <Form.Control.Feedback type="invalid">
    //                     {formItem.error}
    //                   </Form.Control.Feedback>
    //                 </Form.Group>
    //             );
    //           }
    //
    //         })}
    //       </Form>
    //     </Modal.Body>
    //     <Modal.Footer>
    //       {isNarrow && modalConfig.leftButtonText &&
    //           <YuJaButton
    //             onClick={(e) => {
    //               e.preventDefault();
    //               modalConfig.left();
    //             }}
    //           >
    //               {modalConfig.leftButtonText}
    //           </YuJaButton>
    //       }
    //       {
    //         modalConfig.showOtherButton &&
    //         <YuJaButton
    //           onClick={(e) => {
    //             e.preventDefault();
    //             modalConfig.otherButtonSubmit();
    //           }}
    //         >
    //           {modalConfig.otherButtonText}
    //       </YuJaButton>
    //       }
    //       <YuJaButton type="secondary"  onClick={handleClose}>Cancel</YuJaButton>
    //       <YuJaButton
    //           onClick={(e) => {
    //             e.preventDefault();
    //             if(validateForm()) {
    //               modalConfig.submit();
    //             }
    //           }}
    //       >{modalConfig.submitButtonText}</YuJaButton>
    //     </Modal.Footer>
    //   </Spin>
    // </Modal>
  );
}
